import React, { useContext } from "react";
import { FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);

  const handleLogOut = () => {
    logout()
      .then(() => {})
      .catch((err) => console.log(err));
  };

  const menuItems = (
    <React.Fragment>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/blog">Blog</Link>
      </li>
      {user ? (
        <>
          {" "}
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>
        </>
      ) : (
        <>
          {" "}
          <li>
            <Link to="/login">Login</Link>
          </li>
        </>
      )}
      {user ? (
        <>
          {" "}
          <li onClick={handleLogOut}>
            <Link>Logout</Link>
          </li>
        </>
      ) : (
        ""
      )}
      <li>
        <p>{user?.email}</p>
      </li>
      <li>
        <i class="fa-solid fa-user"></i>
      </li>
    </React.Fragment>
  );

  return (
    <div className="navbar bg-base-100 flex justify-between border border-bottom rounded-2xl">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={1}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}{" "}
            <p className="h-[30px] w-[30px] rounded-full">
              {<FaStar className="text-white bg-white"></FaStar>}
            </p>
          </ul>
        </div>
        <Link to="/" className="btn btn-ghost normal-case text-xl">
          Phones Stall
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0  rounded-lg">
          {menuItems}{" "}
          <p className="h-[30px] w-[30px] rounded-full">
            {/* {<FaUser className="text-white bg-white"></FaUser>} */}
          </p>
        </ul>
      </div>
      <label
        tabIndex={2}
        htmlFor="dashboard-drawer"
        className="btn btn-ghost lg:hidden"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h8m-8 6h16"
          />
        </svg>
      </label>
    </div>
  );
};

export default Navbar;
